import { Editor, Transforms, Path, Range, Element } from 'slate';
import { BaseBlockFormat, LinkElement } from 'components/_new/NewSlateEditor/types';

export const createLinkNode = (url: string, openInNewTab: boolean, text: string): LinkElement => ({
	type: BaseBlockFormat.LINK,
	url,
	openInNewTab,
	children: [{ text }],
});

export const insertLink = (editor: Editor, { url, openInNewTab }: { url: string; openInNewTab?: boolean }) => {
	if (!url) {
		return;
	}

	const { selection } = editor;
	const link = createLinkNode(url, openInNewTab || false, 'Link');
	if (selection) {
		const [parent, parentPath] = Editor.parent(editor, selection.focus.path);
		if ((parent as any).type === 'link') {
			removeLink(editor);
		}

		// @ts-ignore
		if (editor.isVoid(parent)) {
			Transforms.insertNodes(editor, { type: BaseBlockFormat.PARAGRAPH, children: [link] } as any, {
				at: Path.next(parentPath),
				select: true,
			});
		} else if (Range.isCollapsed(selection)) {
			Transforms.insertNodes(editor, link as any, { select: true });
		} else {
			Transforms.wrapNodes(editor, link as any, { split: true });
		}
	} else {
		Transforms.insertNodes(editor, { type: BaseBlockFormat.PARAGRAPH, children: [link] } as any);
	}
};

export const removeLink = (editor: Editor) => {
	Transforms.unwrapNodes(editor, {
		match: (n) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'link',
	});
};
